import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/projects/weryze/os-storefront-green/src/app/blogs/[category]/[articleHandle]/BlogDetailClient.tsx");
